module.exports = __webpack_public_path__ + "img/menu_top_bar.b1d9bd92.png";